import { appActionTypes } from './mountedComponents.actions'
import { combineReducers } from 'redux'
import { watchFetchDataSaga } from '../../application/sagas/fetchSaga'
const appSagas = [watchFetchDataSaga]

const MOUNTED_COMPONENTS_REDUCER_INITIAL_STATE = {
  mountedComponents: [],
  reducers: {},
  sagas: appSagas,
}

function addMountedComponent(state, newComponentProps) {
  const { component, name: componentName, sagas = [] } = newComponentProps
  const newState = {
    mountedComponents: [
      ...state.mountedComponents,
      {
        [componentName]: component,
      },
    ],
    sagas: [...state.sagas, ...sagas],
  }
  return { ...state, ...newState }
}

function registerDynamicReducer(state, addedReducers) {
  const newConstructedState = {
    ...state.reducers,
    ...addedReducers,
  }
  return {
    ...state,
    ...{
      reducers: newConstructedState,
    },
  }
}

export function mountedComponentReducer(state = MOUNTED_COMPONENTS_REDUCER_INITIAL_STATE, action) {
  switch (action.type) {
    case appActionTypes.COMPONENT_MOUNT:
      return addMountedComponent(state, action.state)
    case appActionTypes.REGISTER_REDUCER:
      return registerDynamicReducer(state, action.state)
    default:
  }
  return state
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/mountedComponents/mountedComponents.reducers.js